module.exports = __webpack_public_path__ + "img/20180815_150609_098.1b94081e.jpg";